import { REVIEWED_DATES, formatReviewedDate } from "../lib/reviewed";

/**
 * A small, restrained "Last reviewed" marker for guide pages.
 * Pass an explicit `path` OR let it read the current route (default:
 * caller passes the path so we do not have to depend on react-router
 * hooks here — keeping this component pure).
 */
export default function LastReviewed({ path, className = "" }) {
  const iso = REVIEWED_DATES[path];
  if (!iso) return null;
  const label = formatReviewedDate(iso);
  return (
    <p
      data-testid="last-reviewed"
      className={`text-xs font-accent text-ink-muted ${className}`}
    >
      Last reviewed{" "}
      <time dateTime={iso} className="text-ink">
        {label}
      </time>
      .
    </p>
  );
}
